/** Retire legacy Service Workers and their obsolete application caches. */
(function () {
  "use strict";

  var cleanupTasks = [];

  if ("serviceWorker" in navigator) {
    cleanupTasks.push(
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        return Promise.all(
          registrations.map(function (registration) {
            return registration.unregister();
          })
        );
      })
    );
  }

  if ("caches" in window) {
    cleanupTasks.push(
      caches.keys().then(function (names) {
        return Promise.all(
          names
            .filter(function (name) {
              return name.indexOf("kaspi-") === 0;
            })
            .map(function (name) {
              return caches.delete(name);
            })
        );
      })
    );
  }

  Promise.allSettled(cleanupTasks).catch(function () {
    // Cleanup is best-effort and must never delay or break page rendering.
  });
})();
